import { intl } from "LocaleWrapper";
import { useApolloClient } from "@apollo/client";
import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { ChildPropsFromArray } from "types/commons";
import { GetSailingSchedulesDocument, GetSailingSchedulesQuery } from "__generated__/view/sailingschedules/graphql/queries.generated";

export type SailingScheduleSelectOption = ChildPropsFromArray<GetSailingSchedulesQuery, "sailingSchedules">

const SailingScheduleSelect = ({ ...rest }: Omit<SelectProps<SailingScheduleSelectOption, false>, "fetchOptions" | "paginated" | "multiple">) => {

	const client = useApolloClient();

	const onFetchOptions = async () => {

		const result = await client.query({
			query: GetSailingSchedulesDocument,
		});

		return {
			options: result.data.sailingSchedules ?? [],
			totalResults: result.data.sailingSchedules?.length ?? 0,
		};
	};

	return (
		<Select
			fetchOptions={onFetchOptions}
			getOptionLabel={(option) => option?.schedule ?? ""}
			loadingLabel={intl.formatMessage({ id: "LOADING_DATA" })}
			{...rest}
		/>
	);
};

export default SailingScheduleSelect;
